// extracted by mini-css-extract-plugin
export var dividerContainer = "_90-0";
export var line = "_90-1";